import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {Loader, Card, Row, Col} from 'components';
import {PageFooter, Pagination, Table, Icon} from 'components/layout';
import {BranchSelect} from 'components/forms';
import Callout from 'components/tools/Callout';
import DealerApi from 'api/dealer';
import session from 'services/sessionService';


import {getMultipleSystems} from 'api/dataCleanup';

import nextTick from 'helpers/nextTick';

class Page extends React.Component {
  state = {
    loading: true,
    results: [],
    page: 1,
    total: 0,
    sortKey: 'name',
    sortDirection: 'asc',
    dealer: {},
  };

  componentWillMount() {
    DealerApi.getDealer(session.getUser().dealerId)
    .then(dealer => {
      this.setState({
        dealer,
      });
      this._find();
    });
  }

  componentDidUpdate(nextProps, nextState) {
    if (nextState.page !== this.state.page || nextState.sortKey !== this.state.sortKey || nextState.sortDirection !== this.state.sortDirection) {
      this._find();
    }
  }

  onPageChange = (page) => {
    this.setState({page});
  };

  _find = () => {
    getMultipleSystems(this.branches ? this.branches.getWrappedInstance().getValue() : null, this.state.page, this.state.sortKey, this.state.sortDirection)
      .then(x => {
        this.setState({
          results: x.results,
          loading: false,
          page: x.page,
          total: x.total,
        });
      });
  };

  recordAddress = (id, address) => {
    let dict = this.state.toSave || {};

    dict[id] = address;
    this.setState({toSave: dict});
  };

  sort = (key) => {
    if (key !== this.state.sortKey) {
      this.setState({
        sortKey: key,
      });
    } else {
      this.setState({
        sortDirection: this.state.sortDirection === 'asc' ? 'desc' : 'asc',
      });
    }
  };

  render() {
    let {dealer} = this.state;
    let {formatMessage} = this.props.intl;
    let headings = [
      undefined,
      {label: formatMessage({id: 'general.account'}), sortKey: 'accountNo'},
      {label: formatMessage({id: 'general.customer'}), sortKey: 'name'},
      {label: formatMessage({id: 'general.address'}), sortKey: 'address1'},
      {label: formatMessage({id: 'general.pool'}), style: {textAlign: 'center'}, sortKey: 'numberPools'},
      {label: formatMessage({id: 'general.spa'}), style: {textAlign: 'center'}, sortKey: 'numberSpas'},
      {label: formatMessage({id: 'general.swim.spas'}), style: {textAlign: 'center'}, sortKey: 'numberSwimSpas'},
    ];

    let rows = this.state.results.map(customer => <Record
      customer = {customer}
      dealer = {dealer}
      key={customer.Id}
      id={customer.Id}
      onClick={() => location.hash = '#/customer/' + customer.Id + '/merge-systems-report/0'}
      formatMessage={formatMessage}
     />);

    return <div>
      <Card fullWidth>
        <Row>
          <Col md={4}>
            <BranchSelect ref={b => this.branches = b} onChange={() => nextTick(this._find())} />
          </Col>
          <Col md={12}>
            <p className='semi-bold' style={{fontSize: '1.1em'}}>
              <Icon name='help-circle' className='blue fa-lg' /><Callout>{this.state.total}</Callout> <FormattedMessage id="tools.multiple.accounts.systems" />
            </p>
          </Col>
        </Row>
      </Card>
      <Loader loaded={!this.state.loading}>
        <Table headings={headings} rows={rows} sort={this.sort} currentSort={this.state.sortKey} sortDirection={this.state.sortDirection} />
        <PageFooter className='tc'>
          <Pagination onPageChange={this.onPageChange} page={this.state.page} count={25} total={this.state.total} />
        </PageFooter>
      </Loader>
    </div>;
  }
}

const Record = ({onClick, customer, dealer, formatMessage}) => {
  let star;

  if (customer.truBlueActive && dealer.isTruBlueEligible) {
    star = <i className='bl bl-tru-blue-filled fa-lg blue' title={formatMessage({id: 'trublue.raindrop.status.active'})} />;
  } else if ((customer.truBlueInactive || customer.truBlueEligible || customer.truBlueOpportunity) && dealer.isTruBlueEligible) {
    star = <i className='bl bl-tru-blue-filled fa-lg grey' title={`${customer.truBlueInactive ? formatMessage({id: 'trublue.raindrop.status.inactive'}) :
      customer.truBlueEligible ? formatMessage({id: 'trublue.raindrop.status.eligible'}) :
      formatMessage({id: 'trublue.raindrop.status.opportunity'})}`} />;
  } else if (customer.fav) {
    star = <i className='bl bl-star-filled fa-lg star' title={formatMessage({id: 'general.preferred.customer'})} />;
  }

  return <tr onClick={onClick} style={{cursor: 'pointer'}}>
    <td>
      {customer.flag ? <Icon lg name='flag-filled' /> : null}
      {star}
    </td>
    <td>{customer.accountNo}</td>
    <td className='underline'>{customer.name}</td>
    <td>{customer.address1}</td>
    <td style={{textAlign: 'center'}}>{customer.numberPools || 0}</td>
    <td style={{textAlign: 'center'}}>{customer.numberSpas || 0}</td>
    <td style={{textAlign: 'center'}}>{customer.numberSwimSpas || 0}</td>
  </tr>;
};

Record.propTypes = {
  accountNumber: PropTypes.string,
  address: PropTypes.string,
  formatMessage: PropTypes.any,
  name: PropTypes.string,
  numberPools: PropTypes.number,
  numberSpas: PropTypes.number,
  numberSwimSpas: PropTypes.number,
  onClick: PropTypes.func,
};

export default injectIntl(Page);
